export function isDocument(node) {
  return node.nodeName === '#document';
}